export var PoolType;
(function (PoolType) {
    PoolType["V2"] = "V2";
    PoolType["V3_100"] = "V3_100";
    PoolType["V3_500"] = "V3_500";
    PoolType["V3_3000"] = "V3_3000";
    PoolType["V3_10000"] = "V3_10000";
})(PoolType || (PoolType = {}));
